<template>
  <p :class="`${textColor} ${colorClass} ${sizeClass}`">&nbsp;{{ versionText }}</p>
  <a target="_blank" :class="`${textColor} ${colorClass} ${sizeClass}`" :href="COPYRIGHT_URI">{{ $t("app_copyright") }} </a>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { useConfig } from "@/composables";

export default defineComponent({
  name: "CopyrightElem",
  props: {
    color: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "",
    },
    gray: {
      type: Boolean,
      default: false,
    },
    // この環境の eIM サーバーの版（CC_NTTC-1451 A-5）。AC の版と同じく商用では出さない
    esimVersion: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    const { COPYRIGHT_URI, APP_ENVIRONMENT_PROD, APP_ENV, APP_VERSION } = useConfig();
    const isProduction = computed(() => APP_ENV === APP_ENVIRONMENT_PROD);
    const { t } = useI18n();
    // AC の版と eSIM の版。どちらも商用では出さない
    const versionText = computed(() => {
      if (isProduction.value) return "";
      const app = APP_VERSION ? t("app_version", { version: APP_VERSION }) : "";
      const esim = props.esimVersion ? t("esim_version", { version: props.esimVersion }) : "";
      return app + esim;
    });
    const colorClass = computed(() => {
      switch (props.color) {
        case "black":
          return "text-black";
        case "gray":
          return "text-grey";
        default:
          return "text-white";
      }
    });
    const sizeClass = computed(() => {
      switch (props.size) {
        case "small":
          return "small-text";
        default:
          return "";
      }
    });
    const textColor = computed(() => (props.gray ? "gray-text" : "text-white"));
    return {
      COPYRIGHT_URI,
      versionText,
      colorClass,
      sizeClass,
      textColor,
    };
  },
});
</script>

<style scoped>
.small-text {
  font-size: 12px;
}
.gray-text {
  color: #4e4e4e;
}
</style>
